import { create } from "zustand";
import { createJSONStorage, persist } from "zustand/middleware";

import { GoalStore, GoalStoreProps, StorageKey } from "@ctypes";

export const useGoalStore = create<GoalStore>()(
  persist(
    (set) => ({
      goalProps: {},
      setGoalProps: (goalProps: GoalStoreProps) => set(() => ({ goalProps })),
    }),
    {
      name: StorageKey.GoalProps,
      storage: createJSONStorage(() => sessionStorage),
      partialize: (state) => ({ goalProps: state.goalProps }),
    },
  ),
);
